import { MicrosoftTemplate, CustomTemplate } from 'types/template';
import WizardButtonWrapper from '../../Wizard/WizardButtonWrapper';
import { isMicrosoftTemplate } from 'utils/templateGuards';
import TemplateReview from '../TemplateReview';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

export default function LaunchTemplate({
  selectedTemplate,
  onModalClose,
  onClick,
}: {
  selectedTemplate: MicrosoftTemplate | CustomTemplate;
  onModalClose: () => void;
  onClick: () => void;
}) {
  const shouldUseSimpleUI = isMicrosoftTemplate(selectedTemplate);
  return (
    <div className="">
      <div className="d-flex flex-column p-2">
        {shouldUseSimpleUI ? (
          <div>
            <span className="text-muted fs-7">Template Name</span>
            <span className="fs-5 fw-normal d-block">
              {selectedTemplate.label}
            </span>
          </div>
        ) : (
          <TemplateReview
            description={selectedTemplate?.description}
            channels={selectedTemplate?.channels}
            label={selectedTemplate.label}
          />
        )}
      </div>
      <WizardButtonWrapper onModalClose={onModalClose}>
        <div className="d-flex">
          <StylishNewButton className="button--primary ms-2" onClick={onClick}>
            Launch
          </StylishNewButton>
        </div>
      </WizardButtonWrapper>
    </div>
  );
}
